import React, {Component, Fragment} from 'react';
import { connect, Provider } from 'react-redux';
import isMobile from 'ismobilejs';
import ReactDOM from 'react-dom';
import { Scrollbars } from 'react-custom-scrollbars';

import $ from 'jquery'
import isEmpty from 'lodash/isEmpty';
import Draggabilly from 'draggabilly'

import Resizer from '../Resizer/index';
import DonatePanel from "../DonatePanel";
import PmMessage from '../PmMessage/index';
import PmMessageNotification from '../PmMessageNotification/index';
import TextInput from '../UIKit/TextInput/index';
import Snapshot from '../UserInfoTooltip/Snapshot';
import PmServiceMessage from '../PmServiceMessage/index';
import PmWindowContextMenu from '../PmWindowContextMenu/index';
import PmTypingNotification from '../PmTypingNotification/index';
import ChatEditorSmilePopup from '../ChatEditorSmilePopup/index';

import Registry from '../../../registry/index';
import {getUserCSSClass} from '../BobTVUser/index';
import * as VirtualWindowManager from '../VirtualWindowManager/index';
import AnonymousLoginPopup from "../AnonymousLoginPopup";


import PmConversation from 'pm-js/build/components/PmConversation';

import {
    minimizePmWindow,
    maximizePmWindow,
    hidePmWindow
} from '../../../actions/pm';

import {openVideoWindow} from '../../../actions/streaming';
import {closeNotificationsWindow} from '../../../actions/notifications';


import {STATE_UNDEFINED, 
    STATE_REQUESTED_BY_RECIPIENT, 
    STATE_REQUESTED_BY_ME, 
    STATE_DENIED_BY_RECIPIENT, 
    STATE_DENIED_BY_ME, 
    STATE_ALLOWED} from '../../../constants/pm.js';

export class PmWindow extends Component {
    constructor(props) {
        super(props);

        this.state = {showDonatePanel: false};
        
        this.dragMove = this.dragMove.bind(this);
        this.sendPmMessage = this.sendPmMessage.bind(this);
        this.sendTypingNotify = this.sendTypingNotify.bind(this);
        this._onPmMessageSendSuccess = this._onPmMessageSendSuccess.bind(this);
        this._onPmMessageSendError = this._onPmMessageSendError.bind(this);

        this.onContextMenuOpen = this.onContextMenuOpen.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
        this.onAgreeClick = this.onAgreeClick.bind(this);
        this.onRefuseClick = this.onRefuseClick.bind(this);
        this.onPmSendClick = this.onPmSendClick.bind(this);
        this.insertSmile = this.insertSmile.bind(this);

        this.historyAnimated = false;
        this.history = false;

        this.pmConversationRef = React.createRef();
    }
    
    switchDonatePanel = () => {
        const {showDonatePanel} = this.state;
        this.setState({showDonatePanel: !showDonatePanel});
    }
    

    sendPmMessage() {
        let messageText = this.editorInstance.value();
        let chatInterface = Registry.get('chatInterface'),
            {pmConversation} = this.props,
            user = pmConversation.user;

     //   if (!pmConversation.online) return false;

        if (messageText) {
            //console.log("Sending pm message...");
            chatInterface.sendPmMessage(messageText, user, this._onPmMessageSendSuccess, this._onPmMessageSendError);
            this.editorInstance.clearEditor();
        } else {
            //console.log('PM message empty, sending abort');
        }

        //if (browser.phone) editorInstance.blur();
    }

    sendTypingNotify() {
        let chatInterface = Registry.get('chatInterface'),
            {pmConversation} = this.props,
            user = pmConversation.user;

        if (!pmConversation.online) return false;

        // throttling notifying
        let wait = false;
        return function () {
            if (!wait) {
                chatInterface.sendPmTypingNotify(user.uid);
                wait = true;
                setTimeout(function () {
                    wait = false;
                }, 5000);
            }
        }


    }

    _onPmMessageSendSuccess() {
        //console.log("pm message sent");
        // this.editorInstance.clearEditor();
    }

    _onPmMessageSendError() {
        console.log("pm message send ERROR");
    }

    animatePMChatLog() {
        var $chatLog = $(this.chatLog);
        if (!$chatLog) return;
        var $logParent = $(this.chatLog).parent();
        if (!$logParent || $logParent.length == 0) return;
        var offset = $logParent[0].scrollHeight;

        if (offset < 0 || offset > $logParent.height()) {
            if (offset < 0)
                offset = $logParent.scrollTop() + offset;
            $logParent.animate({scrollTop: offset}, 300);

            return true;
        }

        return false;
    }

    dragMove() {
        if (this._smilePopup) {
            this._smilePopup.close();
        }
    }

    onUserConnected() {
        this._serviceMessage = "user_connected";
    }

    onUserDisconnected() {
        this._serviceMessage = "user_disconnected";
    }

    onAgreeClick() {
        let chatInterface = Registry.get('chatInterface'),
            user = this.props.pmConversation.user;

        chatInterface.allowPmAccess(user.uid);
    }

    onRefuseClick() {
        let chatInterface = Registry.get('chatInterface'),
            user = this.props.pmConversation.user;

        chatInterface.denyPmAccess(user.uid);
    }

    onPmSendClick() {
        this.editorInstance.sendEnteredMessage();
    }

    insertSmile(smile) {
        this.editorInstance.insertSmile(smile);
    }

    minimize() {
        let $window = $(this.pmWindow.current);

        $window.fadeOut(200, function () {
            $(this).css("display", "");
        });
    }

    minimizeWindow() {
        let {pmConversation, minimizePmWindow} = this.props,
            {user} = pmConversation;

        minimizePmWindow(user);
    }

    hideWindow() {
        let {pmConversation, hidePmWindow} = this.props,
            {user} = pmConversation;

        hidePmWindow(user);
    }

    maximize() {
        let $window = $(this.pmWindow.current);

        $window.css("opacity", 0.0).animate({opacity: 1.0}, 200);
    }

    onCancelClick() {
        let chatInterface = Registry.get('chatInterface'),
            user = this.props.pmConversation.user;

        chatInterface.cancelPmRequest(user.uid);
    }

    onContextMenuOpen() {
        this.contextMenu.open();

        // Fix bottom offset to fit the context menu on the screen
        window.setTimeout(() => { //Let menu to take it's dimensions

            let contextMenuElement = this.pmWindow.current.getElementsByClassName("block-pm-context-menu")[0];
            let contextMenuBounding = contextMenuElement.getBoundingClientRect();

            let pmBounding = this.pmWindow.current.getBoundingClientRect();
            let windowHeight = (window.innerHeight || document.documentElement.clientHeight);

            const menuHeightOverflow = contextMenuBounding.height ? contextMenuBounding.height - pmBounding.height + 6 : 47;

            if (pmBounding.bottom+menuHeightOverflow > windowHeight) {
                let extraOffsetNeeded = pmBounding.bottom + menuHeightOverflow - windowHeight;
                this.pmWindow.current.style.top = (parseInt(this.pmWindow.current.style.top, 10) - extraOffsetNeeded) + "px";
            }

        }, 300);

    }

    onClickAnonymous(event) {
        typeof event == 'object' && event.preventDefault();

        AnonymousLoginPopup.open();
    }

    componentDidMount() {
        let {browser, pmConversation} = this.props;
        
        if (browser.desktop) {
            this.draggabilly = new Draggabilly(this.pmWindow.current, {
                handle: ".text",
                containment: document.body
            });

            this.draggabilly.on('dragMove', this.dragMove);

            this.pmWindow.current.className += ' virtual-window';
            VirtualWindowManager.register(this.pmWindow.current);

            this.pmWindow.current.style.position = 'absolute';
            this.pmWindow.current.style.left = (window.innerWidth / 2 - 180) + 'px';
            this.pmWindow.current.style.top = (window.innerHeight / 2 - 235) + 'px';
        }

        this.contextMenu.setAnchor(this.contextMenuAnchor);
    }

    componentWillUpdate(nextProps, nextState) {
        let prevpmConversation = this.props.pmConversation,
            nextpmConversation = nextProps.pmConversation;

        // minimize
        if (prevpmConversation.view.maximized && !nextpmConversation.view.maximized) {
            this.minimize();
        }

        // maximize
        if (!prevpmConversation.view.maximized && nextpmConversation.view.maximized) {
            this.maximize();
        }
    }

    componentDidUpdate(prevProps, prevState) {

        let prevpmConversation = prevProps.pmConversation,
            {pmConversation} = this.props;

        if (pmConversation.messages.length > prevpmConversation.messages.length) {
            this.animatePMChatLog();
        }

        if (pmConversation.view.maximized && !prevpmConversation.view.maximized) {
            if (this.pmConversationRef.current) {
                this.pmConversationRef.current.scrollChatToBottom();
            }
            this.animatePMChatLog();
        }

        if (pmConversation.notification || this._serviceMessage) {
            this.animatePMChatLog();
        }

        if (this.history && !this.historyAnimated) {
            this.historyAnimated = this.animatePMChatLog();
        }

        this._serviceMessage = false;
    }

    componentWillUnmount() {
        let {browser} = this.props;

        if (browser.desktop) {
            VirtualWindowManager.unregister(this.pmWindow.current);

            this.draggabilly.off('dragMove', this.dragMove);
            this.draggabilly.destroy();
        }

        ChatEditorSmilePopup.unmount({user: this.props.pmConversation.user});
    }

    openSmilePopup() {
        if (!this._smilePopup) {
            this._smilePopup = ChatEditorSmilePopup.mount({
                insertSmileFn: this.insertSmile,
                ref: (r) => {
                    this._smilePopup = r;
                    this._smilePopup.setAnchor(this._smilePopupIcon);
                    this._smilePopup.open();
                }
            });
        } else {
            this._smilePopup.open();
        }
    }

    insertSmile(smile) {
        // TODO: this breaks encapsulation in many ways
        if(this.pmConversationRef.current) {
            this.pmConversationRef.current.editorInstance.current.editorInstance.insertSmile(smile);
        }
    }

    renderSmilesControl() {
        let disabled = false;

        return (<a className={'smile popup-opener' + (disabled ? ' disabled' : '')}
                href="#"
                ref={(smilePopupIcon) => this._smilePopupIcon = smilePopupIcon}
                onClick={() => !disabled ? this.openSmilePopup() : false}>
            </a>);
    }

    renderTextInputSuffix() {
        return (<div className="block-smile">
                    {this.renderSmilesControl()}
                </div>);
    }

    renderGeneralContent() {
        let pmConversation = this.props.pmConversation;
        let user = this.props.connectedUser;
        let snapshotDisplayed = user.thumbnail || user.snapshot ? <Snapshot user={user} currentUser={this.props.currentUser} openVideoWindow={this.props.openVideoWindow} /> : null;


        return (<PmConversation
            pmConversation={pmConversation}
            ref={this.pmConversationRef}
            textInputSuffix={this.renderTextInputSuffix()}
            snapshot={snapshotDisplayed}/>)
    }

    getTitle() {
        let lang = Registry.get('locale');
        let pmConversation = this.props.pmConversation;
        let user = this.props.pmConversation.user;

        if (pmConversation.generalStatus != 'allowed') {
            return user.nick;
        }
        
        if (user.chatrooms && user.chatrooms.length > 0) {
            return lang.pm_user_connected(user, true);
        } else {
            return lang.pm_user_disconnected(user);
        }
    }

    

    render() {
        let lang = Registry.get('locale');
        let store = Registry.get('store');
        const {showDonatePanel} = this.state;


        let {pmConversation, parentState, currentUser, currentRoom, browser, hideFn, openVideoWindow} = this.props,
            user = pmConversation.user,
            isAnonymous = currentUser.isAnonymous();

        const showDonateButton = pmConversation.generalStatus == "allowed"
                              || pmConversation.generalStatus == "requested_by_me";


        let snapshotDisplayed = user.thumbnail || user.snapshot ? <Snapshot user={user} currentUser={currentUser} openVideoWindow={openVideoWindow} /> : null;
        let genderClass = getUserCSSClass(currentUser, user);

        let userStatusClasses = ['info'];
        if (user.audio) userStatusClasses.push('audio');
        if (user.watching) userStatusClasses.push('watching');
        if (user.streaming) userStatusClasses.push('streaming');

        let windowStatus = [];
        if (browser.desktop) windowStatus.push('virtual-window');
        if (pmConversation.view.maximized) {
            windowStatus.push("shown");
        }

        if (!isAnonymous) {
            windowStatus.push(parentState.general);
        } else {
            windowStatus.push("allowed");
        }

        if (!pmConversation.view.maximized) windowStatus.push('minimized');
        if (pmConversation.view.maximized) windowStatus.push('active');
        if (!pmConversation.online) windowStatus.push('disconnected');

        if (parentState.userBlocked) windowStatus.push('user-blocked');
        if (parentState.meBlocked) windowStatus.push('me-blocked');
    
        this.pmWindow = React.createRef();
    
        
        
        const tip_received_notifications = pmConversation.messages.filter(item => item.type === 'tip_private_received');
        
        const isDesktop = !isMobile.any;

        let divId = "pm-window-" + pmConversation.user.uid;
        //showDonatePanel = true;

        return (
            <div id={divId} className={'popup-pm-window ' + windowStatus.join(' ')} ref={this.pmWindow}>
                <div className="top">
                    <div className="fono" />
                    <div className="text">
                        <div className="more-vert popup-opener" onClick={() => this.onContextMenuOpen()} ref={(moreVert) => this.contextMenuAnchor = moreVert} />
                        <p className="name">
                            <span className={'user-type-icon ' + genderClass} /> <a href="#" title={this.getTitle()}>{this.getTitle()}</a>
                        </p>
                        <span className="minimize" title={lang.minimize_pm} onClick={this.minimizeWindow.bind(this)} />
                    </div>
                </div>
                
                <PmWindowContextMenu
                    user={this.props.connectedUser}
                    currentUser={currentUser}
                    currentRoom={currentRoom}
                    browser={browser}
                    userStatusClasses={userStatusClasses}
                    genderClass={genderClass}
                    hideFn={this.hideWindow.bind(this)}
                    openVideoWindow={openVideoWindow}
                    ref={(contextMenu) => this.contextMenu = contextMenu}
                />

                {showDonatePanel ?
                        <DonatePanel
                            pm
                            user={user}
                            onClose={this.switchDonatePanel}
                        />
                        : showDonateButton ? 
                              <div className="donate-button" onClick={this.switchDonatePanel} />
                              : null
                    }

                <Provider store={store}>
                    {this.renderGeneralContent()}
                </Provider>
                
                <Resizer target={this.pmWindow} />
                
            </div>
        )
    } 

}


function findUser(state, user) {
    // We have to replace PM user with currently connected user or 
    // PmWindowContextMenu will not allow us to 'View' this user
    let connectedUser = state.users.get({uid: user.uid})
    if (connectedUser && connectedUser.online) {
        return connectedUser;
    }
    return user;
}

function mapStateToProps(state, ownProps) {
    let user = ownProps.pmConversation.user;
    let connectedUser = findUser(state, user);
    return {
        connectedUser: connectedUser,
        currentUser: state.currentUser,
        currentRoom: state.currentRoom,
        browser: state.browser
    };
}

let mapDispatchToProps = {
    minimizePmWindow,
    maximizePmWindow,
    hidePmWindow,
    openVideoWindow, // used in UserContextMenu/PmWindowContextMenu
    closeNotificationsWindow
};

export default connect(mapStateToProps, mapDispatchToProps)(PmWindow);




// WEBPACK FOOTER //
// ./src/components/bobtv-neo/PmWindow/index.js